function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "check_inline_svg__Icon_feather-check",
  "data-name": "Icon feather-check",
  d: "M9.333 17.832a1.5 1.5 0 01-1.061-.439L4.939 14.06a1.5 1.5 0 112.121-2.121l2.272 2.272L15.6 7.939a1.5 1.5 0 012.121 2.121l-7.332 7.332a1.5 1.5 0 01-1.056.44z",
  transform: "translate(-4.5 -7.5)",
  fill: "#070556"
});

function SvgCheckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.665,
    height: 10.332,
    viewBox: "0 0 13.665 10.332"
  }, props), _ref);
}

export default SvgCheckinline;